function submitClone(elt, cloneElt) {
  $(cloneElt).click((e) => {
    e.preventDefault();
    $(elt)[0].click();
  });
}

module.exports = submitClone;
